<template>
  <div class="app-container" style="height: calc(100vh - 170px); overflow-y: auto">
    <el-divider>{{ $t('customerManagements.otherInformation') }}</el-divider>
    <el-form ref="formDataOther" :model="formData">
      <el-row :gutter="20">
        <el-col :span="12">
          <!--返回单号规则-->
          <el-form-item
            :label="$t('customerManagements.orderNumberType')"
            :rules="[
              {
                required: true,
                message: $t('customerManagements.pleaseInput'),
                trigger: ['blur', 'change']
              }
            ]"
            prop="orderNumberType"
          >
            <el-select
              v-model="formData.orderNumberType"
              :placeholder="$t('customerManagements.default')"
            >
              <el-option :key="1" :value="1" label="AJ" />
              <el-option :key="2" :value="2" label="ANJBR" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <!--是否启用配货单-->
          <el-form-item
            :label="$t('customerManagements.enableDistributionOrder')"
            prop="deliveryNoteFlag"
          >
            <el-select
              v-model="formData.deliveryNoteFlag"
              :placeholder="$t('customerManagements.default')"
            >
              <el-option :key="0" :label="$t('GlobalSetObj.disable')" :value="0" />
              <el-option :key="1" :label="$t('GlobalSetObj.enable')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 是否启用轨迹停更预警 -->
          <el-form-item :label="$t('trajectory.enableTrackingAlert')" prop="isTrackStopAlert">
            <el-select
              v-model="formData.isTrackStopAlert"
              :placeholder="$t('customerManagements.pleaseChoose')"
            >
              <el-option :key="0" :label="$t('GlobalSetObj.disable')" :value="0" />
              <el-option :key="1" :label="$t('GlobalSetObj.enable')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--轨迹停更时长预警阈值-->
          <el-form-item
            :label="$t('trajectory.trackingDurationThreshold')"
            prop="trackStopAlertDays"
          >
            <el-select
              v-model="formData.trackStopAlertDays"
              :placeholder="$t('customerManagements.pleaseChoose')"
            >
              <el-option
                v-for="item in 19"
                :key="item"
                :label="item + 1 + '天'"
                :value="item + 1"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      v-if="customer.type === 'edit' || customer.type === 'add'"
      slot="footer"
      class="dialog-footer"
      style="text-align: right"
    >
      <el-button @click="clearData()">{{ $t('customerManagements.cancel') }}</el-button>
      <el-button
        type="primary" @click="onSubmit()"
      >{{ $t('customerManagements.confirm') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { apiCustomerEditOther } from '@/api/customer';

export default {
  name: 'OtherInformation',
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      }
    },
    customer: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: {
        orderNumberType: 1,
        deliveryNoteFlag: 0,
        isTrackStopAlert: 0, // 是否启用轨迹停更预警：0-否，1-是
        trackStopAlertDays: '' // 轨迹停更时长预警阈值（天）
      }
    };
  },
  created() {
    console.log(this.detailData, 'this.detailData');
    const detailData = this.detailData || {};
    this.formData = {
      orderNumberType: detailData.orderNumberType,
      deliveryNoteFlag: this.customer.deliveryNoteFlag || 0,
      customerId: detailData.id,
      isTrackStopAlert: detailData.isTrackStopAlert || 0,
      trackStopAlertDays: detailData.trackStopAlertDays || ''
    };
  },
  methods: {
    // 取消
    clearData() {
      this.$emit('updataData', true);
    },
    // 提交
    onSubmit() {
      this.$refs['formDataOther'].validate((valid) => {
        if (valid) {
          const formData = {
            customerId: this.detailData.id,
            customerConfig: {
              orderNumberType: this.formData.orderNumberType,
              deliveryNoteFlag: this.formData.deliveryNoteFlag || 0,
              isTrackStopAlert: this.formData.isTrackStopAlert,
              trackStopAlertDays: this.formData.trackStopAlertDays || ''
            }
          };
          apiCustomerEditOther(formData).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: this.$t('customerManagements.ModificationSuccessful'),
                type: 'success'
              });
              this.$emit('updataData');
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped></style>
